import './styles/graphic.scss';

export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
    // width,
    // height
  } = props;


  const gunsGP4_data = {
    India: '6,145',
    France: '1,748',
    Brazil: '1,259',
    Argentina: '1,204',
    Russia: '1,053',
    Mexico: '914',
    Germany: '899',
    Pakistan: '710',
    Venezuela: '702',
    Canada: '686',
    Turkey: '585',
    Ukraine: '525',
    Italy: '507',
    Colombia: '478',
    'China_(mainland)': '467',
    Nigeria: '458',
    Iraq: '428',
    South_Africa: '397',
    Dem_Rep_Congo: '395',
    Thailand: '382',
    Ethiopia: '340',
    Iran: '256',
    Bangladesh: '231',
    Austria: '220',
    Switzerland: '217',
    Serbia: '208',
    Spain: '205',
    Tanzania: '203',
    Kenya: '195',
    Australia: '185',
    Egypt: '183',
    Mozambique: '182',
    Belgium: '180',
    Uruguay: '163',
    Ivory_Coast: '157',
    Portugal: '156',
    Indonesia: '154',
    Cameroon: '152',
    Finland: '147',
    Vietnam: '144',
    Czech_Republic: '140',
    Nepal: '132',
    Somalia: '129',
    Sweden: '124',
    Burkina_Faso: '120',
    Chile: '120',
    United_Kingdom: '117',
    Sudan: '112',
    Angola: '111',
    Philippines: '110',
    Uganda: '108',
    Madagascar: '106',
    Saudi_Arabia: '103',
    Afghanistan: '98',
    Israel: '97',
    Greece: '97',
    Dominican_Republic: '96',
    Morocco: '95',
    Malawi: '95',
    Ghana: '94',
    Yemen: '91',
    Zambia: '91',
    Ecuador: '90',
    Zimbabwe: '89',
    Niger: '89',
    Mali: '87',
    Paraguay: '86',
    Senegal: '85',
    Chad: '81',
    Croatia: '79',
    Norway: '72',
    Algeria: '71',
    Guinea: '67',
    Bulgaria: '65',
    Guatemala: '64',
    Costa_Rica: '60',
    Burundi: '60',
    Haiti: '60',
    Poland: '59',
    Benin: '56',
    Denmark: '54',
    Belarus: '53',
    Central_African_Republic: '51',
    Slovakia: '50',
    Kazakhstan: '48',
    Rwanda: '48',
    Myanmar: '47',
    Hungary: '47',
    Bolivia: '46',
    Japan: '45',
    Netherlands: '44',
    Togo: '43',
    Eritrea: '43',
    Lesotho: '42',
    Malaysia: '42',
    Peru: '41',
    New_Zealand: '39',
    Sierra_Leone: '38',
    United_Arab_Emirates: '37',
    Honduras: '35',
    Slovenia: '32',
    Puerto_Rico: '30',
    South_Sudan: '29',
    North_Korea: '29',
    Cuba: '28',
    Albania: '26',
    'Bosnia-Herzegovina': '26',
    Georgia: '25',
    Congo: '23',
    South_Korea: '23',
    Liberia: '21',
    Montenegro: '21',
    Botswana: '21',
    Mongolia: '21',
    Nicaragua: '19',
    North_Macedonia: '19',
    Tunisia: '19',
    Ireland: '18',
    Papua_New_Guinea: '18',
    Sri_Lanka: '18',
    Uzbekistan: '17',
    Lithuania: '17',
    Jamaica: '17',
    Syria: '17',
    Taiwan: '16',
    Libya: '16',
    Latvia: '16',
    Cambodia: '15',
    Namibia: '15',
    Armenia: '15',
    'Guinea-Bissau': '14',
    Eswatini: '14',
    Estonia: '12',
    Solomon_Islands: '12',
    Mauritania: '11',
    Romania: '11',
    Cyprus: '10',
    Gambia: '10',
    El_Salvador: '10',
    Azerbaijan: '10',
    Greenland: '9',
    Jordan: '9',
    Laos: '9',
    Gabon: '8',
    Lebanon: '8',
    Moldova: '8',
    Panama: '7',
    Kyrgyzstan: '7',
    Suriname: '6',
    Luxembourg: '6',
    Turkmenistan: '6',
    Cabo_Verde: '5',
    Djibouti: '5',
    Iceland: '4',
    Equatorial_Guinea: '3',
    Vanuatu: '3',
    Guyana: '3',
    Belize: '3',
    'West_Bank+Gaza': '3',
    Kuwait: '3',
    Comoros: '3',
    Tajikistan: '3',
    Guam: '3',
    US_Virgin_Islands: '2',
    Malta: '2',
    Trinidad_and_Tobago: '2',
    Oman: '2',
    Bahrain: '1',
    Singapore: '1',
    Qatar: '1',
    San_Marino: '1',
    Micronesia: '1',
    Bhutan: '1',
    Mauritius: '1',
    'East-Timor': '1',
    Samoa: '1',
    Monaco: '1',
    Bahamas: '1',
    Barbados: '1',
    Marshall_Islands: '1',
    Saint_Lucia: '1',
    Northern_Mariana_Islands: '1',
    Andorra: '1',
    Maldives: '0',
    Fiji: '0',
    American_Samoa: '0',
    Sao_Tome_and_Principe: '0',
    Brunei_Darussalam: '0',
    Kiribati: '0',
    Tonga: '0',
    Saint_Vincent_and_the_Grenadines: '0',
    Seychelles: '0',
    Palau: '0',
    Nauru: '0',
    Dominica: '0',
    Tuvalu: '0',
    Cook_Islands: '0',
    Antigua_and_Barbuda: '0',
    Saint_Kitts_and_Nevis: '0',
    Grenada: '0',
    Bermuda: '0',
    Niue: '0',
    Tokelau: '0',
  };
  let gns4Sel;
  function gn_4mrk(th, e) {
  		if ((th.getAttribute('data-pop') == undefined) || ((window.innerWidth < 730) && (th.getAttribute('data-pop') == '1'))) {
      document.getElementById('gns4-ctry').innerHTML = th.getAttribute('data-i').split('_').join(' ');
      document.getElementById('gns4-val').innerHTML = gunsGP4_data[th.getAttribute('data-i')];
      const ppb = document.getElementById('popBox');
      ppb.style.top = `${e.offsetY}px`;
      ppb.style.left = `${e.offsetX}px`;
 			ppb.classList.toggle('rts', (e.offsetX > document.getElementById('gunsGP4').getBoundingClientRect().width / 2));
    } else {
      document.getElementById('popBox').classList.remove('inV');
    }
  }

  let pp4pth; let pp4tth;
  document.querySelectorAll('#gunsGP4-hoverA>path').forEach((a, b) => {
    a.addEventListener('mousemove', function (e) {
      gn_4mrk(this, e);
    });
    a.addEventListener('mouseleave', function (e) {
      this.setAttribute('class', '');
      document.getElementById('popBox').classList.remove('inV');
 			if (pp4pth != undefined)pp4pth.setAttribute('class', '');
 			if (pp4tth != undefined)pp4tth.setAttribute('class', '');
    });
    a.addEventListener('mouseenter', function (e) {
      this.setAttribute('class', 'inView');
      document.getElementById('popBox').classList.add('inV');
 			pp4tth = document.getElementById(`tth-${this.getAttribute('data-i')}`);
  			if (pp4tth != undefined) {
        pp4tth.setAttribute('class', 'inView');
  			}
    });
  });


  document.getElementById('guns4-sel').addEventListener('input', function () {
    if (pp4pth != undefined)pp4pth.setAttribute('class', '');
    if (pp4tth != undefined)pp4tth.setAttribute('class', '');
    document.getElementById('popBox').classList.add('inV');
    pp4pth = document.getElementById(`pth-${this.value}`);
    pp4tth = document.getElementById(`tth-${this.value}`);
    const pthbb = pp4pth.getBoundingClientRect();
    const svgp = document.getElementById('guns4-svg').getBoundingClientRect();
    gn_4mrk(pp4pth, { offsetX: (pthbb.left - svgp.left) + (pthbb.width / 2), offsetY: pthbb.top - svgp.top + ((pthbb.height / 2) - 12) });
    pp4pth.setAttribute('class', 'inView');
    if (pp4tth != undefined)pp4tth.setAttribute('class', 'inView');
  });
}
